import React from 'react';
import DisputesTable from './disputesTable';
import DisputesFilter from './disputesFilter';
import DisputeModal from './modal/disputeModal';
import Divider from '../../common/divider';
import PageTitle from '../../common/pageTitle';
import Messages from '../../../configurations/messages';
import Breadcrumbs from 'react-breadcrumbs';
import Toaster from 'toastr';
import { permissioned } from '../../common/permissionedHoc';
import DisputesAPI from '../../../api/DisputesApi';
import Util from '../../../util/util';
import Constants from '../../../configurations/constants';


class DisputesPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            tableData: [],
            totalCount : 0,
            selectedDispute: null,
            loading: false,
            pages : 0,
            pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
            pageNum : 0, //Zero based index
            filterParams : null
        }
        this.onSearchHandler = this.onSearchHandler.bind(this);
        this.onDisputeRowClick = this.onDisputeRowClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
    
    }
    componentDidMount()
    {
        //Load data on mount
        this.onSearchHandler({pageSize : this.state.pageSize});
    }
    onSearchHandler(params, resetPageNumber) {
        //Reset states 
        let stateUpdate  = {loading: true,tableData: []};
        if(resetPageNumber)
        {
            stateUpdate.pageNum  = 0;
            params.pageNum = 1;
        }
        this.setState(stateUpdate);
        params.pageSize =  params.pageSize ||  this.state.pageSize;
        params.pageNum =  params.pageNum ||  (this.state.pageNum + 1);
        

        DisputesAPI.findDisputes(params)
            .then((response) => {
                let data = response.data.content;
                let totalCount = response.data.count;
                let pages = totalCount ? Math.ceil(totalCount / (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)) : 0;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Disputes")

                this.setState({ tableData: data, loading: false, filterParams : params, totalCount : totalCount, pages : pages });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_DISPUTES_SEARCH} - ${error.statusText}`, `${Messages.ERROR_DISPUTES_SEARCH_TITLE} - ${error.status}`);
                this.setState({ loading: false });
            });
    }
    onDisputeRowClick(index) {
        this.setState({ selectedDispute: this.state.tableData[index] });
    }
    handleCloseModal(event, reloadDataFlag) {
        this.setState({ selectedDispute: null });
        if(reloadDataFlag)
        {
            this.onSearchHandler(this.state.filterParams);
        }
    }

    onTableChange(state, instance)
    {
        let pageSize  = instance.state.pageSize;
        let pageNum = (instance.state.page); //table page  - Zero based index
        this.setState({pageSize : pageSize, pageNum : pageNum   }); 
        if(this.state.filterParams)
        {
          let params = Util.clone(this.state.filterParams);
          params.pageSize = pageSize;
          params.pageNum = pageNum + 1;

          this.onSearchHandler(params);   
        }
       
    }

    render() {
        return (
            <div>
                <div id="new-claim-page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Disputes" />
                <DisputesFilter onSearchHandler={this.onSearchHandler} />
                <Divider />
                <DisputesTable
                    onRowClick={this.onDisputeRowClick}
                    tableData={this.state.tableData}
                    loading={this.state.loading} 
                    onTableChange={this.onTableChange} 
                    page={this.state.pageNum}
                    pages={this.state.pages}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}/>
                {
                    this.state.selectedDispute &&
                    <DisputeModal
                        onRequestClose={this.handleCloseModal}
                        isOpen={this.state.selectedDispute != null}
                        dispute={this.state.selectedDispute} />
                }
            </div>
        )
    }
}

export default permissioned(DisputesPage);


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/disputesPage.js